import ConstructiveButton from '@/features/common/buttons/ConstructiveButton'
import DestructiveButton from '@/features/common/buttons/DestructiveButton'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface AcceptedDeliveryTimeButtonsProps {
    onOrderCancel: () => void
    onOrderAccept: () => Promise<void>
}

const AcceptedDeliveryTimeButtons: FC<AcceptedDeliveryTimeButtonsProps> = ({
    onOrderCancel,
    onOrderAccept,
}) => {
    const [acceptOrderLoading, setAcceptOrderLoading] = useState(false)

    const { t } = useTranslation()

    const handleOrderAccept = async () => {
        try {
            setAcceptOrderLoading(true)

            await onOrderAccept()
        } finally {
            setAcceptOrderLoading(false)
        }
    }

    return (
        <View style={styles.container}>
            <DestructiveButton icon disabled={acceptOrderLoading} onPress={onOrderCancel}>
                {t('order.detail.cancel')}
            </DestructiveButton>
            <ConstructiveButton icon disabled={acceptOrderLoading} onPress={handleOrderAccept}>
                {t('order.detail.accept')}
            </ConstructiveButton>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'center',
        width: 400,
        gap: 10,
    },
    button: {
        width: 168,
        borderRadius: 8,
    },
})

export default AcceptedDeliveryTimeButtons
